import React from 'react';
import { Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/styles';
import { BREAKPOINT } from 'utils/responsivenessUtils';

interface Props {
  title: string;
  subtitle?: string;
  height?: number;
}

export const ModalSectionTitle = ({ title, subtitle, height }: Props) => {
  const theme = useTheme();
  const mobileView = useMediaQuery(theme.breakpoints.down(BREAKPOINT));
  const useStyles = makeStyles((t: Theme) => ({
    container: {
      padding: mobileView ? t.spacing(1) : t.spacing(2),
      textAlign: 'center',
    },
  }));
  const classes = useStyles();
  return (
    <div className={classes.container} style={{ height }}>
      <Typography variant={mobileView ? 'h6' : 'h5'}>{title}</Typography>
      {subtitle && <Typography style={{ fontSize: mobileView ? 10 : 12 }}>{subtitle}</Typography>}
    </div>
  );
};
